import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NavService } from '../../core/nav.service';
import { Lecture } from '../shared/lecture';

@Directive({
  selector: 'app-lecture-lessons-nav' // tslint:disable-line:directive-selector
})
export class LectureLessonsNavDirective implements OnInit, OnDestroy {
  constructor(private route: ActivatedRoute, private nav: NavService) { }

  ngOnInit(): void {
    this.nav.articleActions = [
      { commands: ['discussions'], route: this.route.parent }
    ];
  }

  ngOnDestroy(): void {
    this.nav.subList = null;
    this.nav.articleActions = null;
    this.nav.navActions = null;
    this.nav.lectureTitle = null;
  }

  @Input() set lessons(lessons: any[]) {
    if (lessons) {
      this.nav.subList = {
        title: 'Lessons',
        items: lessons.map(lesson => ({
          observableText: lesson.name,
          commands: [lesson.$key],
          route: this.route
        }))
      };

      this.nav.updateNavActions();
    }
  }

  @Input() set lecture(lecture: Lecture) {
    if (lecture) {
        this.nav.lectureTitle = lecture.name;
        this.nav.lecturePublic = lecture.public;
        this.nav.lectureAction = {
          commands: [lecture.$key],
          route: this.route.parent.parent
        };
      }
    }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-lessons/lecture-lessons-nav.directive.ts